import React from "react";
import { Link } from "@quintype/components";
import { object, array, string, bool } from "prop-types";

import LiveText from "../../atoms/LiveText";
import Headline from "../../atoms/Headline";
import KeyHighlights from "../KeyHighlights";

import "./liveBlogStoryCard.m.css";

const LiveBlogStoryCard = ({ story, keyHighlights, updatedFont, publisherLang }) => {
  const headlineStyle = updatedFont ? `${publisherLang}-story-headline` : "";

  return (
    <div styleName="live-blog-story-card" className="live-blog-story-card">
      <Link href={story.url}>
        <LiveText story={story} />
        <Headline text={story.headline} headerLevel={2} headlineType={4} styleName={headlineStyle} />
        {keyHighlights && (
          <div className="key-highlights-wrapper">
            <KeyHighlights keyHighlights={keyHighlights} />
            <div className="key-highlights-after"></div>
          </div>
        )}
      </Link>
    </div>
  );
};

LiveBlogStoryCard.propTypes = {
  story: object.isRequired,
  keyHighlights: array,
  updatedFont: bool,
  publisherLang: string
};

export default LiveBlogStoryCard;
